import { Component } from 'solid-js';

import logo from '../../assets/logo.png';

const Footer: Component = () => {
	// @ts-ignore
	const lastBuildDate =
		new Date(__BUILD_DATE__).toLocaleString() || 'Unknown';

	return (
		<>
			<div class='flex flex-shrink-0 flex-col'>
				<footer class='footer bg-base-200 text-base-content/60 border-base-300 border-t-2 px-10 py-4 '>
					<div class='flex h-full w-full max-w-screen-2xl mx-auto'>
						<div class='flex gap-2 items-center'>
							<img src={logo} alt='logo' width='40' height='40' />
							<div class='flex flex-col'>
								<h3 class='text-base-content font-bold'>
									L'Ordre Francophone des Développeurs Garry's
									Mod
								</h3>
								<p>
									Ce nom de domaine à étais offert par
									l'eminence de sa personne, le grand et
									magnifique{' '}
									<span class='font-bold linear-gradient text-transparent bg-clip-text bg-gradient-to-r from-[#ff0000] to-[#FF4D00]'>
										DynamoRed
									</span>
								</p>
							</div>
						</div>
						<div class='flex-grow h-full flex items-center justify-center' />
						<div class='flex text-right text-base-content/60 h-full items-center'>
							{`Dernière mise à jour le ${lastBuildDate}`}
						</div>
					</div>
				</footer>
			</div>
		</>
	);
};

export default Footer;
